import DotTrigger from './DotTrigger';

export default DotTrigger;
